
// // // src/pages/RegisterWithCommunity.jsx
// // import React, { useMemo, useState } from "react";
// // import {
// //   Container,
// //   Form,
// //   Button,
// //   Alert,
// //   Spinner,
// //   Card,
// //   Row,
// //   Col,
// // } from "react-bootstrap";
// // import { useNavigate } from "react-router-dom";
// // import { auth, db } from "../firebase";
// // import {
// //   doc,
// //   getDoc,
// //   runTransaction,
// //   Timestamp,
// //   setDoc,
// // } from "firebase/firestore";
// // import {
// //   createUserWithEmailAndPassword,
// //   deleteUser,
// //   signOut, sendEmailVerification, updateProfile
// // } from "firebase/auth";



// // /** ---------- Utils ---------- **/

// // /** Fetch a community doc by ID */
// // const fetchCommunityById = async (communityId) => {
// //   const id = (communityId || "").trim();
// //   if (!id) throw new Error("Please enter a Community ID.");
// //   const ref = doc(db, "communities", id);
// //   const snap = await getDoc(ref);
// //   if (!snap.exists()) {
// //     const err = new Error("Community not found. Check the ID and try again.");
// //     err.code = "community/not-found";
// //     throw err;
// //   }
// //   return { id, data: snap.data() };
// // };

// // /** floor/flat helpers */
// // const deriveFromStartNumber = (startNumberInput) => {
// //   const s = String(startNumberInput || "").replace(/\D/g, "");
// //   if (!s) return { floorBase: 1, indexStart: 1, indexWidth: 2 };
// //   if (s.length <= 2) {
// //     const indexStart = parseInt(s, 10);
// //     const indexWidth = Math.max(2, s.length);
// //     return { floorBase: 1, indexStart, indexWidth };
// //   }
// //   const floorBase = parseInt(s.slice(0, -2), 10);
// //   const indexStart = parseInt(s.slice(-2), 10);
// //   return { floorBase, indexStart, indexWidth: 2 };
// // };

// // const buildFloorLabels = (block) => {
// //   const labels = [];
// //   if (block.hasGround)
// //     labels.push({ label: `Ground (${block.groundLabel})`, floorNumber: 0 });
// //   for (let f = 1; f <= Number(block.floors || 0); f++) {
// //     labels.push({ label: `Floor ${f}`, floorNumber: f });
// //   }
// //   return labels;
// // };

// // const buildFlatsForFloor = (block, floorNumber) => {
// //   const { floorBase, indexStart, indexWidth } = deriveFromStartNumber(
// //     block.startNumberInput || "101"
// //   );
// //   const count = Number(block.flatsPerFloor || 0);
// //   const out = [];

// //   if (floorNumber === 0) {
// //     for (let i = 0; i < count; i++) {
// //       const idx = indexStart + i;
// //       out.push(
// //         `${block.name}-${block.groundLabel}${String(idx).padStart(indexWidth, "0")}`
// //       );
// //     }
// //     return out;
// //   }

// //   const floorCode = floorBase + (floorNumber - 1);
// //   for (let i = 0; i < count; i++) {
// //     const idx = indexStart + i;
// //     out.push(`${block.name}-${floorCode}${String(idx).padStart(indexWidth, "0")}`);
// //   }
// //   return out;
// // };

// // /** ---------- Component ---------- **/

// // const IMAGE_URL =
// //   "https://images.unsplash.com/photo-1521783593447-5702f9f80c7a?q=80&w=1600&auto=format&fit=crop";

  
// // // ⬇️ Paste this helper function here
// // async function sendVerificationWithLogs(user, communityId, fullName) {
// //   if (fullName?.trim()) {
// //     try {
// //       await updateProfile(user, { displayName: fullName.trim() });
// //       console.log("[verify] displayName set:", fullName.trim());
// //     } catch (e) {
// //       console.warn("[verify] updateProfile failed:", e);
// //     }
// //   }

// //   const actionCodeSettings = {
// //     url: `${window.location.origin}/verify-success?community=${communityId}`,
// //     handleCodeInApp: false,
// //   };

// //   try {
// //     console.log("[verify] sending email to:", user.email, "with continueUrl:", actionCodeSettings.url);
// //     await sendEmailVerification(user, actionCodeSettings);
// //     console.log("[verify] sendEmailVerification SUCCESS for:", user.email);
// //     return true;
// //   } catch (e) {
// //     console.error("[verify] sendEmailVerification FAILED:", e?.code, e?.message, e);
// //     return false;
// //   }
// // }


// // async function resendVerification() {
// //   const user = auth.currentUser;
// //   if (!user) return alert("Please sign in first.");
// //   await sendEmailVerification(user, {
// //     url: `${window.location.origin}/verify-success`,
// //     handleCodeInApp: false,
// //   });
// //   alert("Verification email resent. Check your inbox.");
// // }



// // export default function RegisterWithCommunity() {
// //   // Step 1
// //   const [communityId, setCommunityId] = useState("");
// //   const [community, setCommunity] = useState(null);
// //   const [fetching, setFetching] = useState(false);
// //   const [fetchError, setFetchError] = useState("");

// //   // Step 2
// //   const [showRegisterForm, setShowRegisterForm] = useState(false);

// //   // Selections
// //   const [selectedBlockId, setSelectedBlockId] = useState("");
// //   const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
// //   const [selectedFlatLabel, setSelectedFlatLabel] = useState("");

// //   // Availability
// //   const [availableFlats, setAvailableFlats] = useState([]);
// //   const [availLoading, setAvailLoading] = useState(false);

// //   // Form
// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [fullName, setFullName] = useState("");
// //   const [mobile, setMobile] = useState("");

// //   // ✅ new: must agree to terms
// //   const [agreed, setAgreed] = useState(false);

// //   const [registerError, setRegisterError] = useState("");
// //   const [registering, setRegistering] = useState(false);

// //   const navigate = useNavigate();

// //   const handleFetch = async () => {
// //     setFetchError("");
// //     setCommunity(null);
// //     setShowRegisterForm(false);

// //     setSelectedBlockId("");
// //     setSelectedFloorNumber(null);
// //     setSelectedFlatLabel("");
// //     setAvailableFlats([]);

// //     const id = communityId.trim();
// //     if (!id) {
// //       setFetchError("Please enter a Community ID.");
// //       return;
// //     }

// //     try {
// //       setFetching(true);
// //       const result = await fetchCommunityById(id);
// //       setCommunity(result);
// //     } catch (err) {
// //       console.error("Fetch community error:", err.code, err.message);
// //       setFetchError(err.message || "Unable to fetch community.");
// //     } finally {
// //       setFetching(false);
// //     }
// //   };

// //   const handleProceedToRegister = () => {
// //     setShowRegisterForm(true);
// //     setRegisterError("");
// //   };

// //   const blocks = useMemo(() => {
// //     if (!community?.data?.blocks || !Array.isArray(community.data.blocks))
// //       return [];
// //     return community.data.blocks;
// //   }, [community]);

// //   const floorOptions = useMemo(() => {
// //     const block = blocks.find((b) => b.id === selectedBlockId);
// //     if (!block) return [];
// //     return buildFloorLabels(block);
// //   }, [blocks, selectedBlockId]);

// //   const refreshAvailableFlats = async () => {
// //     setAvailableFlats([]);
// //     setSelectedFlatLabel("");
// //     setAvailLoading(true);
// //     try {
// //       const block = blocks.find((b) => b.id === selectedBlockId);
// //       if (!block || selectedFloorNumber === null) return;

// //       const all = buildFlatsForFloor(block, selectedFloorNumber);
// //       const occupancy = block.occupancy || {};
// //       const avail = all.filter((label) => !occupancy[label]);
// //       setAvailableFlats(avail);
// //     } finally {
// //       setAvailLoading(false);
// //     }
// //   };

  
// // const handleRegister = async () => {
// //   setRegisterError("");

// //   if (!community?.id) return setRegisterError("Please fetch your community first.");
// //   if (!selectedBlockId) return setRegisterError("Please select a block.");
// //   if (selectedFloorNumber === null) return setRegisterError("Please select a floor.");
// //   if (!selectedFlatLabel) return setRegisterError("Please select a flat number.");
// //   if (!email || !password) return setRegisterError("Please enter email and password.");
// //   if (!agreed) return setRegisterError("Please agree to the terms to continue.");

// //   const block = blocks.find((b) => b.id === selectedBlockId);
// //   if (!block) return setRegisterError("Invalid block selection.");

// //   try {
// //     setRegistering(true);

// //     // 1) Create auth user
// //     const { user } = await createUserWithEmailAndPassword(
// //       auth,
// //       email.trim(),
// //       password
// //     );

// //     // 2) Claim flat in a transaction
// //     const communityRef = doc(db, "communities", community.id);
// //     await runTransaction(db, async (t) => {
// //       const snap = await t.get(communityRef);
// //       if (!snap.exists()) throw new Error("Community not found during claim.");
// //       const data = snap.data();
// //       const blocksArr = Array.isArray(data.blocks) ? [...data.blocks] : [];
// //       const idx = blocksArr.findIndex((b) => b.id === selectedBlockId);
// //       if (idx < 0) throw new Error("Selected block not found.");

// //       const target = { ...blocksArr[idx] };
// //       const occupancy = { ...(target.occupancy || {}) };
// //       if (occupancy[selectedFlatLabel]) {
// //         throw new Error("Selected flat is already occupied. Please choose another flat.");
// //       }

// //       occupancy[selectedFlatLabel] = user.uid;
// //       target.occupancy = occupancy;
// //       blocksArr[idx] = target;

// //       t.update(communityRef, { blocks: blocksArr });
// //     });

// //     // 3) User profile in Firestore
// //     const userRef = doc(db, "users", user.uid);
// //     const userSnap = await getDoc(userRef);
// //     const existing = userSnap.exists() ? userSnap.data() : {};
// //     const communities = Array.isArray(existing.communities)
// //       ? Array.from(new Set([...existing.communities, community.id]))
// //       : [community.id];

// //     await setDoc(
// //       userRef,
// //       {
// //         uid: user.uid,
// //         role: "resident",
// //         email: email.trim(),
// //         fullName: fullName.trim() || null,
// //         mobile: mobile.trim() || null,
// //         communities,
// //         unit: {
// //           communityId: community.id,
// //           blockName: block.name,
// //           floorNumber: selectedFloorNumber,
// //           flatLabel: selectedFlatLabel,
// //         },
// //         status: "pending",            // you can gate features until verified
// //         profileCompleted: true,
// //         authProvider: "password",
// //         createdAt: Timestamp.now(),
// //       },
// //       { merge: true }

      


// //     );

    
// // // inside handleRegister, right after setDoc(...) succeeds
// // const ok = await sendVerificationWithLogs(user, community.id, fullName);
// // if (!ok) {
// //   setRegisterError(
// //     "We couldn’t send the verification email. Please use 'Resend verification' or check your spam folder."
// //   );
// // }

// // // Navigate after sending (keeping user signed in)
// // navigate(`/resident/${community.id}?verificationEmailSent=1`);


// //     // 4) OPTIONAL: Set displayName so your template's %DISPLAY_NAME% gets a value
// //     if (fullName.trim()) {
// //       try {
// //         await updateProfile(user, { displayName: fullName.trim() });
// //       } catch (e) {
// //         // non-fatal
// //         console.warn("Could not update display name:", e);
// //       }
// //     }

// //     // 5) Send the verification email (triggers your Auth template)
// //     const actionCodeSettings = {
// //       // Redirect back to your app after successful verification (must be authorized)
// //       url: `${window.location.origin}/verify-success?community=${community.id}`,
// //       // We let Firebase-hosted page handle the code. Set true only if you want to handle link in-app.
// //       handleCodeInApp: false,
// //     };

// //     await sendEmailVerification(user, actionCodeSettings);

// //     // 6) UX: Either keep the user signed-in with "pending" status,
// //     // or sign them out and ask them to verify first. Choose one flow:

// //     // (A) Keep signed-in; show a banner inside /resident/... to verify email:
// //     navigate(`/resident/${community.id}?verificationEmailSent=1`);

// //     // (B) Or sign out and send them to a "Check your inbox" page:
// //     /*
// //     await signOut(auth);
// //     navigate(`/check-email?sent=1&email=${encodeURIComponent(email.trim())}`);
// //     */

// //   } catch (err) {
// //     console.error("Register error:", err.code, err.message, err);
// //     // cleanup newly created auth user on failure
// //     if (auth.currentUser) {
// //       try {
// //         await deleteUser(auth.currentUser);
// //       } catch (cleanupErr) {
// //         console.warn("Could not delete newly created user:", cleanupErr);
// //       }
// //       await signOut(auth).catch(() => {});
// //     }
// //     setRegisterError(err?.message || "Registration failed. Please try again.");
// //   } finally {
// //     setRegistering(false);
// //   }
// // };


// //   // const handleRegister = async () => {
// //   //   setRegisterError("");

// //   //   if (!community?.id) return setRegisterError("Please fetch your community first.");
// //   //   if (!selectedBlockId) return setRegisterError("Please select a block.");
// //   //   if (selectedFloorNumber === null) return setRegisterError("Please select a floor.");
// //   //   if (!selectedFlatLabel) return setRegisterError("Please select a flat number.");
// //   //   if (!email || !password) return setRegisterError("Please enter email and password.");
// //   //   if (!agreed) return setRegisterError("Please agree to the terms to continue.");

// //   //   const block = blocks.find((b) => b.id === selectedBlockId);
// //   //   if (!block) return setRegisterError("Invalid block selection.");

// //   //   try {
// //   //     setRegistering(true);

// //   //     // 1) Auth user
// //   //     const { user } = await createUserWithEmailAndPassword(
// //   //       auth,
// //   //       email.trim(),
// //   //       password
// //   //     );

// //   //     // 2) Claim flat
// //   //     const communityRef = doc(db, "communities", community.id);
// //   //     await runTransaction(db, async (t) => {
// //   //       const snap = await t.get(communityRef);
// //   //       if (!snap.exists()) throw new Error("Community not found during claim.");
// //   //       const data = snap.data();
// //   //       const blocksArr = Array.isArray(data.blocks) ? [...data.blocks] : [];
// //   //       const idx = blocksArr.findIndex((b) => b.id === selectedBlockId);
// //   //       if (idx < 0) throw new Error("Selected block not found.");

// //   //       const target = { ...blocksArr[idx] };
// //   //       const occupancy = { ...(target.occupancy || {}) };
// //   //       if (occupancy[selectedFlatLabel]) {
// //   //         throw new Error("Selected flat is already occupied. Please choose another flat.");
// //   //       }

// //   //       occupancy[selectedFlatLabel] = user.uid;
// //   //       target.occupancy = occupancy;
// //   //       blocksArr[idx] = target;

// //   //       t.update(communityRef, { blocks: blocksArr });
// //   //     });

// //   //     // 3) Profile
// //   //     const userRef = doc(db, "users", user.uid);
// //   //     const userSnap = await getDoc(userRef);
// //   //     const existing = userSnap.exists() ? userSnap.data() : {};
// //   //     const communities = Array.isArray(existing.communities)
// //   //       ? Array.from(new Set([...existing.communities, community.id]))
// //   //       : [community.id];

// //   //     await setDoc(
// //   //       userRef,
// //   //       {
// //   //         uid: user.uid,
// //   //         role: "resident",
// //   //         email: email.trim(),
// //   //         fullName: fullName.trim() || null,
// //   //         mobile: mobile.trim() || null,
// //   //         communities,
// //   //         unit: {
// //   //           communityId: community.id,
// //   //           blockName: block.name,
// //   //           floorNumber: selectedFloorNumber,
// //   //           flatLabel: selectedFlatLabel,
// //   //         },
// //   //         status: "pending",
// //   //         profileCompleted: true,
// //   //         authProvider: "password",
// //   //         createdAt: Timestamp.now(),
// //   //       },
// //   //       { merge: true }
// //   //     );

// //   //     navigate(`/resident/${community.id}`);
// //   //   } catch (err) {
// //   //     console.error("Register error:", err.code, err.message, err);
// //   //     // cleanup newly created auth user on failure
// //   //     if (auth.currentUser) {
// //   //       try {
// //   //         await deleteUser(auth.currentUser);
// //   //       } catch (cleanupErr) {
// //   //         console.warn("Could not delete newly created user:", cleanupErr);
// //   //       }
// //   //       await signOut(auth).catch(() => {});
// //   //     }
// //   //     setRegisterError(err?.message || "Registration failed. Please try again.");
// //   //   } finally {
// //   //     setRegistering(false);
// //   //   }
// //   // };

// //   const resetCommunity = () => {
// //     setCommunity(null);
// //     setCommunityId("");
// //     setFetchError("");
// //     setShowRegisterForm(false);

// //     setSelectedBlockId("");
// //     setSelectedFloorNumber(null);
// //     setSelectedFlatLabel("");
// //     setAvailableFlats([]);

// //     setEmail("");
// //     setPassword("");
// //     setFullName("");
// //     setMobile("");
// //     setAgreed(false);
// //     setRegisterError("");
// //   };

// //   return (
// //     <Container className="py-4 py-md-5" style={{ minHeight: "100vh" }}>
// //       <Row className="justify-content-center">
// //         <Col xs={12} lg={10} xl={9}>
// //           <Card className="overflow-hidden shadow register-card rounded-4">
// //             <Row className="g-0">
// //               {/* Left visual */}
// //               <Col md={5} className="d-none d-md-block">
// //                 <div className="register-visual h-100">
// //                   <img
// //                     src={IMAGE_URL}
// //                     alt="Welcome to your community"
// //                     className="register-visual-img"
// //                   />
// //                   <div className="register-visual-overlay">
// //                     <div className="register-visual-text">
// //                       <h2 className="mb-1">Join your community</h2>
// //                       <p className="mb-0">Simple registration. Secure access.</p>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </Col>

// //               {/* Right form */}
// //               <Col xs={12} md={7}>
// //                 <Card.Body className="p-3 p-md-4">
// //                   <h2 className="mb-1">Resident Registration</h2>
// //                   <p className="text-muted mb-4">
// //                     Find your community, pick your flat, and create your account.
// //                   </p>

// //                   {/* Step 1 */}
// //                   <section className="mb-4 pb-3 border-bottom">
// //                     <h5 className="mb-3">Step 1: Identify Your Community</h5>

// //                     {fetchError && <Alert variant="danger">{fetchError}</Alert>}

// //                     {!community ? (
// //                       <>
// //                         <Form.Group className="mb-3">
// //                           <Form.Label>Community ID</Form.Label>
// //                           <Form.Control
// //                             type="text"
// //                             placeholder="e.g., ABC12345"
// //                             value={communityId}
// //                             onChange={(e) => setCommunityId(e.target.value.toUpperCase())}
// //                           />
// //                         </Form.Group>

// //                         <Button className="primary-cta" onClick={handleFetch} disabled={fetching}>
// //                           {fetching ? (
// //                             <>
// //                               <Spinner animation="border" size="sm" className="me-2" /> Fetching…
// //                             </>
// //                           ) : (
// //                             "Fetch"
// //                           )}
// //                         </Button>
// //                       </>
// //                     ) : (
// //                       <>
// //                         <Alert variant="info">
// //                           <div>
// //                             <strong>Community ID:</strong> <code>{community.id}</code>
// //                           </div>
// //                           <div>
// //                             <strong>Name:</strong> {community.data.name}
// //                           </div>
// //                           <div>
// //                             <strong>Address:</strong> {community.data.address}
// //                           </div>
// //                           {community.data.description && (
// //                             <div>
// //                               <strong>Description:</strong> {community.data.description}
// //                             </div>
// //                           )}
// //                         </Alert>
// //                         <div className="d-flex gap-2">
// //                           <Button variant="outline-secondary" onClick={resetCommunity}>
// //                             Check another Community
// //                           </Button>
// //                           <Button className="primary-cta" onClick={handleProceedToRegister}>
// //                             Proceed to Register
// //                           </Button>
// //                         </div>
// //                       </>
// //                     )}
// //                   </section>

// //                   {/* Step 2 */}
// //                   {community && showRegisterForm && (
// //                     <section>
// //                       <h5 className="mb-3">Step 2: Choose Block / Floor / Flat</h5>

// //                       <Row className="g-2">
// //                         {/* Block */}
// //                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                           <Form.Label>Block</Form.Label>
// //                           <Form.Select
// //                             value={selectedBlockId}
// //                             onChange={(e) => {
// //                               setSelectedBlockId(e.target.value);
// //                               setSelectedFloorNumber(null);
// //                               setSelectedFlatLabel("");
// //                               setAvailableFlats([]);
// //                             }}
// //                           >
// //                             <option value="">Select block</option>
// //                             {blocks.map((b) => (
// //                               <option key={b.id} value={b.id}>
// //                                 {b.name} - Block
// //                               </option>
// //                             ))}
// //                           </Form.Select>
// //                         </Form.Group>

// //                         {/* Floor */}
// //                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                           <Form.Label>Floor</Form.Label>
// //                           <Form.Select
// //                             value={selectedFloorNumber ?? ""}
// //                             disabled={!selectedBlockId}
// //                             onChange={(e) => {
// //                               const val = e.target.value === "" ? null : Number(e.target.value);
// //                               setSelectedFloorNumber(val);
// //                               setSelectedFlatLabel("");
// //                               setAvailableFlats([]);
// //                             }}
// //                             onBlur={refreshAvailableFlats}
// //                             onFocus={() => {
// //                               if (selectedBlockId && selectedFloorNumber !== null)
// //                                 refreshAvailableFlats();
// //                             }}
// //                           >
// //                             <option value="">Select floor</option>
// //                             {floorOptions.map(({ label, floorNumber }) => (
// //                               <option key={`floor-${floorNumber}`} value={floorNumber}>
// //                                 {label}
// //                               </option>
// //                             ))}
// //                           </Form.Select>
// //                           <Form.Text muted>
// //                             Ground availability uses the same numbering pattern as upper floors.
// //                           </Form.Text>
// //                         </Form.Group>

// //                         {/* Flat */}
// //                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
// //                           <Form.Label>Flat number</Form.Label>
// //                           <Form.Select
// //                             value={selectedFlatLabel}
// //                             disabled={!selectedBlockId || selectedFloorNumber === null}
// //                             onFocus={refreshAvailableFlats}
// //                             onChange={(e) => setSelectedFlatLabel(e.target.value)}
// //                           >
// //                             <option value="">
// //                               {availLoading ? "Checking availability…" : "Select available flat"}
// //                             </option>
// //                             {!availLoading &&
// //                               availableFlats.map((label) => (
// //                                 <option key={label} value={label}>
// //                                   {label}
// //                                 </option>
// //                               ))}
// //                           </Form.Select>
// //                         </Form.Group>
// //                       </Row>

// //                       <hr />

// //                       {/* Account info */}
// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Full name (optional)</Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           value={fullName}
// //                           onChange={(e) => setFullName(e.target.value)}
// //                           placeholder="e.g., Rahul Sharma"
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Mobile (optional)</Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           value={mobile}
// //                           onChange={(e) => setMobile(e.target.value)}
// //                           placeholder="e.g., 9876543210"
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Email</Form.Label>
// //                         <Form.Control
// //                           type="email"
// //                           autoComplete="username"
// //                           placeholder="name@example.com"
// //                           value={email}
// //                           onChange={(e) => setEmail(e.target.value)}
// //                         />
// //                       </Form.Group>

// //                       <Form.Group className="mb-3">
// //                         <Form.Label>Password</Form.Label>
// //                         <Form.Control
// //                           type="password"
// //                           autoComplete="new-password"
// //                           placeholder="Enter a strong password"
// //                           value={password}
// //                           onChange={(e) => setPassword(e.target.value)}
// //                         />
// //                       </Form.Group>

// //                       {/* ✅ Terms */}
// //                       <Form.Group className="mb-3">
// //                         <Form.Check
// //                           id="agree-terms"
// //                           type="checkbox"
// //                           label="I agree to the Terms & Privacy Policy."
// //                           checked={agreed}
// //                           onChange={(e) => setAgreed(e.target.checked)}
// //                         />
// //                       </Form.Group>

// //                       {registerError && (
// //                         <Alert variant="danger" className="mb-3">
// //                           {registerError}
// //                         </Alert>
// //                       )}

// //                       <div className="register-action-bar">
// //                         <Button className="primary-cta" onClick={handleRegister} disabled={registering}>
// //                           {registering ? (
// //                             <>
// //                               <Spinner animation="border" size="sm" className="me-2" /> Registering…
// //                             </>
// //                           ) : (
// //                             "Register"
// //                           )}
// //                         </Button>
// //                       </div>
// //                     </section>
// //                   )}

// //                   <p className="mt-4 mb-0 text-muted">Your safety is our prime priority.</p>
// //                 </Card.Body>
// //               </Col>
// //             </Row>
// //           </Card>
// //         </Col>
// //       </Row>
// //     </Container>
// //   );
// // }


// // src/pages/RegisterWithCommunity.jsx
// import React, { useMemo, useState } from "react";
// import {
//   Container,
//   Form,
//   Button,
//   Alert,
//   Spinner,
//   Card,
//   Row,
//   Col,
// } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import { auth, db } from "../firebase";
// import {
//   doc,
//   getDoc,
//   runTransaction,
//   Timestamp,
//   setDoc,
// } from "firebase/firestore";
// import {
//   createUserWithEmailAndPassword,
//   deleteUser,
//   signOut,
//   sendEmailVerification,
//   updateProfile,
// } from "firebase/auth";

// /** ---------- Utils ---------- **/

// /** Fetch a community doc by ID */
// const fetchCommunityById = async (communityId) => {
//   const id = (communityId || "").trim();
//   if (!id) throw new Error("Please enter a Community ID.");
//   const ref = doc(db, "communities", id);
//   const snap = await getDoc(ref);
//   if (!snap.exists()) {
//     const err = new Error("Community not found. Check the ID and try again.");
//     err.code = "community/not-found";
//     throw err;
//   }
//   return { id, data: snap.data() };
// };

// /** floor/flat helpers */
// const deriveFromStartNumber = (startNumberInput) => {
//   const s = String(startNumberInput || "").replace(/\D/g, "");
//   if (!s) return { floorBase: 1, indexStart: 1, indexWidth: 2 };
//   if (s.length <= 2) {
//     const indexStart = parseInt(s, 10);
//     const indexWidth = Math.max(2, s.length);
//     return { floorBase: 1, indexStart, indexWidth };
//   }
//   const floorBase = parseInt(s.slice(0, -2), 10);
//   const indexStart = parseInt(s.slice(-2), 10);
//   return { floorBase, indexStart, indexWidth: 2 };
// };

// const buildFloorLabels = (block) => {
//   const labels = [];
//   if (block.hasGround)
//     labels.push({ label: `Ground (${block.groundLabel})`, floorNumber: 0 });
//   for (let f = 1; f <= Number(block.floors || 0); f++) {
//     labels.push({ label: `Floor ${f}`, floorNumber: f });
//   }
//   return labels;
// };

// const buildFlatsForFloor = (block, floorNumber) => {
//   const { floorBase, indexStart, indexWidth } = deriveFromStartNumber(
//     block.startNumberInput || "101"
//   );
//   const count = Number(block.flatsPerFloor || 0);
//   const out = [];

//   if (floorNumber === 0) {
//     for (let i = 0; i < count; i++) {
//       const idx = indexStart + i;
//       out.push(
//         `${block.name}-${block.groundLabel}${String(idx).padStart(indexWidth, "0")}`
//       );
//     }
//     return out;
//   }

//   const floorCode = floorBase + (floorNumber - 1);
//   for (let i = 0; i < count; i++) {
//     const idx = indexStart + i;
//     out.push(`${block.name}-${floorCode}${String(idx).padStart(indexWidth, "0")}`);
//   }
//   return out;
// };

// /** ---------- Component ---------- **/

// const IMAGE_URL =
//   "https://images.unsplash.com/photo-1521783593447-5702f9f80c7a?q=80&w=1600&auto=format&fit=crop";

// /** Helper: send email verification with logs and optional displayName */
// async function sendVerificationWithLogs(user, communityId, fullName) {
//   if (fullName?.trim()) {
//     try {
//       await updateProfile(user, { displayName: fullName.trim() });
//       console.log("[verify] displayName set:", fullName.trim());
//     } catch (e) {
//       console.warn("[verify] updateProfile failed:", e);
//     }
//   }

//   const actionCodeSettings = {
//     url: `${window.location.origin}/verify-success?community=${communityId}`,
//     handleCodeInApp: false,
//   };

//   try {
//     console.log(
//       "[verify] sending email to:",
//       user.email,
//       "with continueUrl:",
//       actionCodeSettings.url
//     );
//     await sendEmailVerification(user, actionCodeSettings);
//     console.log("[verify] sendEmailVerification SUCCESS for:", user.email);
//     return true;
//   } catch (e) {
//     console.error("[verify] sendEmailVerification FAILED:", e?.code, e?.message, e);
//     return false;
//   }
// }

// export default function RegisterWithCommunity() {
//   // Step 1
//   const [communityId, setCommunityId] = useState("");
//   const [community, setCommunity] = useState(null);
//   const [fetching, setFetching] = useState(false);
//   const [fetchError, setFetchError] = useState("");

//   // Step 2
//   const [showRegisterForm, setShowRegisterForm] = useState(false);

//   // Selections
//   const [selectedBlockId, setSelectedBlockId] = useState("");
//   const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
//   const [selectedFlatLabel, setSelectedFlatLabel] = useState("");

//   // Availability
//   const [availableFlats, setAvailableFlats] = useState([]);
//   const [availLoading, setAvailLoading] = useState(false);

//   // Form
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [fullName, setFullName] = useState("");
//   const [mobile, setMobile] = useState("");

//   // ✅ must agree to terms
//   const [agreed, setAgreed] = useState(false);

//   const [registerError, setRegisterError] = useState("");
//   const [registering, setRegistering] = useState(false);

//   const navigate = useNavigate();

//   const handleFetch = async () => {
//     setFetchError("");
//     setCommunity(null);
//     setShowRegisterForm(false);

//     setSelectedBlockId("");
//     setSelectedFloorNumber(null);
//     setSelectedFlatLabel("");
//     setAvailableFlats([]);

//     const id = communityId.trim();
//     if (!id) {
//       setFetchError("Please enter a Community ID.");
//       return;
//     }

//     try {
//       setFetching(true);
//       const result = await fetchCommunityById(id);
//       setCommunity(result);
//     } catch (err) {
//       console.error("Fetch community error:", err.code, err.message);
//       setFetchError(err.message || "Unable to fetch community.");
//     } finally {
//       setFetching(false);
//     }
//   };

//   const handleProceedToRegister = () => {
//     setShowRegisterForm(true);
//     setRegisterError("");
//   };

//   const blocks = useMemo(() => {
//     if (!community?.data?.blocks || !Array.isArray(community.data.blocks))
//       return [];
//     return community.data.blocks;
//   }, [community]);

//   const floorOptions = useMemo(() => {
//     const block = blocks.find((b) => b.id === selectedBlockId);
//     if (!block) return [];
//     return buildFloorLabels(block);
//   }, [blocks, selectedBlockId]);

//   const refreshAvailableFlats = async () => {
//     setAvailableFlats([]);
//     setSelectedFlatLabel("");
//     setAvailLoading(true);
//     try {
//       const block = blocks.find((b) => b.id === selectedBlockId);
//       if (!block || selectedFloorNumber === null) return;

//       const all = buildFlatsForFloor(block, selectedFloorNumber);
//       const occupancy = block.occupancy || {};
//       const avail = all.filter((label) => !occupancy[label]);
//       setAvailableFlats(avail);
//     } finally {
//       setAvailLoading(false);
//     }
//   };

//   const handleRegister = async () => {
//     setRegisterError("");

//     if (!community?.id) return setRegisterError("Please fetch your community first.");
//     if (!selectedBlockId) return setRegisterError("Please select a block.");
//     if (selectedFloorNumber === null) return setRegisterError("Please select a floor.");
//     if (!selectedFlatLabel) return setRegisterError("Please select a flat number.");
//     if (!email || !password) return setRegisterError("Please enter email and password.");
//     if (!agreed) return setRegisterError("Please agree to the terms to continue.");

//     const block = blocks.find((b) => b.id === selectedBlockId);
//     if (!block) return setRegisterError("Invalid block selection.");

//     try {
//       setRegistering(true);

//       // 1) Create auth user
//       const { user } = await createUserWithEmailAndPassword(
//         auth,
//         email.trim(),
//         password
//       );
//       console.log("[register] created user:", user.uid, user.email);

//       // 2) Claim flat in a transaction
//       const communityRef = doc(db, "communities", community.id);
//       await runTransaction(db, async (t) => {
//         const snap = await t.get(communityRef);
//         if (!snap.exists()) throw new Error("Community not found during claim.");
//         const data = snap.data();
//         const blocksArr = Array.isArray(data.blocks) ? [...data.blocks] : [];
//         const idx = blocksArr.findIndex((b) => b.id === selectedBlockId);
//         if (idx < 0) throw new Error("Selected block not found.");

//         const target = { ...blocksArr[idx] };
//         const occupancy = { ...(target.occupancy || {}) };
//         if (occupancy[selectedFlatLabel]) {
//           throw new Error("Selected flat is already occupied. Please choose another flat.");
//         }

//         occupancy[selectedFlatLabel] = user.uid;
//         target.occupancy = occupancy;
//         blocksArr[idx] = target;

//         t.update(communityRef, { blocks: blocksArr });
//       });
//       console.log("[register] claimed flat:", selectedFlatLabel, "in block:", block.name);

//       // 3) Save user profile (Firestore)
//       const userRef = doc(db, "users", user.uid);
//       const userSnap = await getDoc(userRef);
//       const existing = userSnap.exists() ? userSnap.data() : {};
//       const communities = Array.isArray(existing.communities)
//         ? Array.from(new Set([...existing.communities, community.id]))
//         : [community.id];

//       await setDoc(
//         userRef,
//         {
//           uid: user.uid,
//           role: "resident",
//           email: email.trim(),
//           fullName: fullName.trim() || null,
//           mobile: mobile.trim() || null,
//           communities,
//           unit: {
//             communityId: community.id,
//             blockName: block.name,
//             floorNumber: selectedFloorNumber,
//             flatLabel: selectedFlatLabel,
//           },
//           status: "pending", // Gate features until verified
//           profileCompleted: true,
//           authProvider: "password",
//           createdAt: Timestamp.now(),
//         },
//         { merge: true }
//       );
//       console.log("[register] saved profile in Firestore for", user.uid);

//       // 4) Send the verification email (with logs + displayName)
//       const ok = await sendVerificationWithLogs(user, community.id, fullName);
//       if (!ok) {
//         setRegisterError(
//           "We couldn’t send the verification email. Please use 'Resend verification' or check your spam folder."
//         );
//       }

//       // 5) Navigate to Check Email page (keeping user signed-in)
//       navigate(
//         `/check-email?community=${encodeURIComponent(community.id)}&email=${encodeURIComponent(
//           email.trim()
//         )}`
//       );
//     } catch (err) {
//       console.error("Register error:", err.code, err.message, err);
//       // cleanup newly created auth user on failure
//       if (auth.currentUser) {
//         try {
//           await deleteUser(auth.currentUser);
//         } catch (cleanupErr) {
//           console.warn("Could not delete newly created user:", cleanupErr);
//         }
//         await signOut(auth).catch(() => {});
//       }
//       setRegisterError(err?.message || "Registration failed. Please try again.");
//     } finally {
//       setRegistering(false);
//     }
//   };

//   const resetCommunity = () => {
//     setCommunity(null);
//     setCommunityId("");
//     setFetchError("");
//     setShowRegisterForm(false);

//     setSelectedBlockId("");
//     setSelectedFloorNumber(null);
//     setSelectedFlatLabel("");
//     setAvailableFlats([]);

//     setEmail("");
//     setPassword("");
//     setFullName("");
//     setMobile("");
//     setAgreed(false);
//     setRegisterError("");
//   };

//   return (
//     <Container className="py-4 py-md-5" style={{ minHeight: "100vh" }}>
//       <Row className="justify-content-center">
//         <Col xs={12} lg={10} xl={9}>
//           <Card className="overflow-hidden shadow register-card rounded-4">
//             <Row className="g-0">
//               {/* Left visual */}
//               <Col md={5} className="d-none d-md-block">
//                 <div className="register-visual h-100">
//                   <img
//                     src={IMAGE_URL}
//                     alt="Welcome to your community"
//                     className="register-visual-img"
//                   />
//                   <div className="register-visual-overlay">
//                     <div className="register-visual-text">
//                       <h2 className="mb-1">Join your community</h2>
//                       <p className="mb-0">Simple registration. Secure access.</p>
//                     </div>
//                   </div>
//                 </div>
//               </Col>

//               {/* Right form */}
//               <Col xs={12} md={7}>
//                 <Card.Body className="p-3 p-md-4">
//                   <h2 className="mb-1">Resident Registration</h2>
//                   <p className="text-muted mb-4">
//                     Find your community, pick your flat, and create your account.
//                   </p>

//                   {/* Step 1 */}
//                   <section className="mb-4 pb-3 border-bottom">
//                     <h5 className="mb-3">Step 1: Identify Your Community</h5>

//                     {fetchError && <Alert variant="danger">{fetchError}</Alert>}

//                     {!community ? (
//                       <>
//                         <Form.Group className="mb-3">
//                           <Form.Label>Community ID</Form.Label>
//                           <Form.Control
//                             type="text"
//                             placeholder="e.g., ABC12345"
//                             value={communityId}
//                             onChange={(e) => setCommunityId(e.target.value.toUpperCase())}
//                           />
//                         </Form.Group>

//                         <Button className="primary-cta" onClick={handleFetch} disabled={fetching}>
//                           {fetching ? (
//                             <>
//                               <Spinner animation="border" size="sm" className="me-2" /> Fetching…
//                             </>
//                           ) : (
//                             "Fetch"
//                           )}
//                         </Button>
//                       </>
//                     ) : (
//                       <>
//                         <Alert variant="info">
//                           <div>
//                             <strong>Community ID:</strong> <code>{community.id}</code>
//                           </div>
//                           <div>
//                             <strong>Name:</strong> {community.data.name}
//                           </div>
//                           <div>
//                             <strong>Address:</strong> {community.data.address}
//                           </div>
//                           {community.data.description && (
//                             <div>
//                               <strong>Description:</strong> {community.data.description}
//                             </div>
//                           )}
//                         </Alert>
//                         <div className="d-flex gap-2">
//                           <Button variant="outline-secondary" onClick={resetCommunity}>
//                             Check another Community
//                           </Button>
//                           <Button className="primary-cta" onClick={handleProceedToRegister}>
//                             Proceed to Register
//                           </Button>
//                         </div>
//                       </>
//                     )}
//                   </section>

//                   {/* Step 2 */}
//                   {community && showRegisterForm && (
//                     <section>
//                       <h5 className="mb-3">Step 2: Choose Block / Floor / Flat</h5>

//                       <Row className="g-2">
//                         {/* Block */}
//                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
//                           <Form.Label>Block</Form.Label>
//                           <Form.Select
//                             value={selectedBlockId}
//                             onChange={(e) => {
//                               setSelectedBlockId(e.target.value);
//                               setSelectedFloorNumber(null);
//                               setSelectedFlatLabel("");
//                               setAvailableFlats([]);
//                             }}
//                           >
//                             <option value="">Select block</option>
//                             {blocks.map((b) => (
//                               <option key={b.id} value={b.id}>
//                                 {b.name} - Block
//                               </option>
//                             ))}
//                           </Form.Select>
//                         </Form.Group>

//                         {/* Floor */}
//                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
//                           <Form.Label>Floor</Form.Label>
//                           <Form.Select
//                             value={selectedFloorNumber ?? ""}
//                             disabled={!selectedBlockId}
//                             onChange={(e) => {
//                               const val =
//                                 e.target.value === "" ? null : Number(e.target.value);
//                               setSelectedFloorNumber(val);
//                               setSelectedFlatLabel("");
//                               setAvailableFlats([]);
//                             }}
//                             onBlur={refreshAvailableFlats}
//                             onFocus={() => {
//                               if (selectedBlockId && selectedFloorNumber !== null)
//                                 refreshAvailableFlats();
//                             }}
//                           >
//                             <option value="">Select floor</option>
//                             {floorOptions.map(({ label, floorNumber }) => (
//                               <option key={`floor-${floorNumber}`} value={floorNumber}>
//                                 {label}
//                               </option>
//                             ))}
//                           </Form.Select>
//                           <Form.Text muted>
//                             Ground availability uses the same numbering pattern as upper floors.
//                           </Form.Text>
//                         </Form.Group>

//                         {/* Flat */}
//                         <Form.Group as={Col} xs={12} md={4} className="mb-3">
//                           <Form.Label>Flat number</Form.Label>
//                           <Form.Select
//                             value={selectedFlatLabel}
//                             disabled={!selectedBlockId || selectedFloorNumber === null}
//                             onFocus={refreshAvailableFlats}
//                             onChange={(e) => setSelectedFlatLabel(e.target.value)}
//                           >
//                             <option value="">
//                               {availLoading ? "Checking availability…" : "Select available flat"}
//                             </option>
//                             {!availLoading &&
//                               availableFlats.map((label) => (
//                                 <option key={label} value={label}>
//                                   {label}
//                                 </option>
//                               ))}
//                           </Form.Select>
//                         </Form.Group>
//                       </Row>

//                       <hr />

//                       {/* Account info */}
//                       <Form.Group className="mb-3">
//                         <Form.Label>Full name (optional)</Form.Label>
//                         <Form.Control
//                           type="text"
//                           value={fullName}
//                           onChange={(e) => setFullName(e.target.value)}
//                           placeholder="e.g., Rahul Sharma"
//                         />
//                       </Form.Group>

//                       <Form.Group className="mb-3">
//                         <Form.Label>Mobile (optional)</Form.Label>
//                         <Form.Control
//                           type="text"
//                           value={mobile}
//                           onChange={(e) => setMobile(e.target.value)}
//                           placeholder="e.g., 9876543210"
//                         />
//                       </Form.Group>

//                       <Form.Group className="mb-3">
//                         <Form.Label>Email</Form.Label>
//                         <Form.Control
//                           type="email"
//                           autoComplete="username"
//                           placeholder="name@example.com"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                         />
//                       </Form.Group>

//                       <Form.Group className="mb-3">
//                         <Form.Label>Password</Form.Label>
//                         <Form.Control
//                           type="password"
//                           autoComplete="new-password"
//                           placeholder="Enter a strong password"
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                         />
//                       </Form.Group>

//                       {/* ✅ Terms */}
//                       <Form.Group className="mb-3">
//                         <Form.Check
//                           id="agree-terms"
//                           type="checkbox"
//                           label="I agree to the Terms & Privacy Policy."
//                           checked={agreed}
//                           onChange={(e) => setAgreed(e.target.checked)}
//                         />
//                       </Form.Group>

//                       {registerError && (
//                         <Alert variant="danger" className="mb-3">
//                           {registerError}
//                         </Alert>
//                       )}

//                       <div className="register-action-bar">
//                         <Button className="primary-cta" onClick={handleRegister} disabled={registering}>
//                           {registering ? (
//                             <>
//                               <Spinner animation="border" size="sm" className="me-2" /> Registering…
//                             </>
//                           ) : (
//                             "Register"
//                           )}
//                         </Button>
//                       </div>
//                     </section>
//                   )}

//                   <p className="mt-4 mb-0 text-muted">Your safety is our prime priority.</p>
//                 </Card.Body>
//               </Col>
//             </Row>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// }


// src/pages/RegisterWithCommunity.jsx
import React, { useMemo, useState } from "react";
import {
  Container,
  Form,
  Button,
  Alert,
  Spinner,
  Card,
  Row,
  Col,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import {
  doc,
  getDoc,
  runTransaction,
  Timestamp,
  setDoc,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  deleteUser,
  signOut,
  sendEmailVerification,
  updateProfile,
} from "firebase/auth";

/** ---------- Utils ---------- **/
const fetchCommunityById = async (communityId) => {
  const id = (communityId || "").trim();
  if (!id) throw new Error("Please enter a Community ID.");
  const ref = doc(db, "communities", id);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    const err = new Error("Community not found. Check the ID and try again.");
    err.code = "community/not-found";
    throw err;
  }
  return { id, data: snap.data() };
};

const deriveFromStartNumber = (startNumberInput) => {
  const s = String(startNumberInput || "").replace(/\D/g, "");
  if (!s) return { floorBase: 1, indexStart: 1, indexWidth: 2 };
  if (s.length <= 2) {
    const indexStart = parseInt(s, 10);
    const indexWidth = Math.max(2, s.length);
    return { floorBase: 1, indexStart, indexWidth };
  }
  const floorBase = parseInt(s.slice(0, -2), 10);
  const indexStart = parseInt(s.slice(-2), 10);
  return { floorBase, indexStart, indexWidth: 2 };
};

const buildFloorLabels = (block) => {
  const labels = [];
  if (block.hasGround)
    labels.push({ label: `Ground (${block.groundLabel})`, floorNumber: 0 });
  for (let f = 1; f <= Number(block.floors || 0); f++) {
    labels.push({ label: `Floor ${f}`, floorNumber: f });
  }
  return labels;
};

const buildFlatsForFloor = (block, floorNumber) => {
  const { floorBase, indexStart, indexWidth } = deriveFromStartNumber(
    block.startNumberInput || "101"
  );
  const count = Number(block.flatsPerFloor || 0);
  const out = [];

  if (floorNumber === 0) {
    for (let i = 0; i < count; i++) {
      const idx = indexStart + i;
      out.push(
        `${block.name}-${block.groundLabel}${String(idx).padStart(indexWidth, "0")}`
      );
    }
    return out;
  }

  const floorCode = floorBase + (floorNumber - 1);
  for (let i = 0; i < count; i++) {
    const idx = indexStart + i;
    out.push(`${block.name}-${floorCode}${String(idx).padStart(indexWidth, "0")}`);
  }
  return out;
};

/** ---------- Component ---------- **/
const IMAGE_URL =
  "https://images.unsplash.com/photo-1521783593447-5702f9f80c7a?q=80&w=1600&auto=format&fit=crop";

async function sendVerificationWithLogs(user, communityId, fullName) {
  if (fullName?.trim()) {
    try {
      await updateProfile(user, { displayName: fullName.trim() });
      console.log("[verify] displayName set:", fullName.trim());
    } catch (e) {
      console.warn("[verify] updateProfile failed:", e);
    }
  }

  const actionCodeSettings = {
    url: `${window.location.origin}/verify-success?community=${communityId}`,
    handleCodeInApp: false,
  };

  try {
    console.log(
      "[verify] sending email to:",
      user.email,
      "with continueUrl:",
      actionCodeSettings.url
    );
    await sendEmailVerification(user, actionCodeSettings);
    console.log("[verify] sendEmailVerification SUCCESS for:", user.email);
    return true;
  } catch (e) {
    console.error("[verify] sendEmailVerification FAILED:", e?.code, e?.message, e);
    return false;
  }
}

export default function RegisterWithCommunity() {
  const [communityId, setCommunityId] = useState("");
  const [community, setCommunity] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [fetchError, setFetchError] = useState("");

  const [showRegisterForm, setShowRegisterForm] = useState(false);

  const [selectedBlockId, setSelectedBlockId] = useState("");
  const [selectedFloorNumber, setSelectedFloorNumber] = useState(null);
  const [selectedFlatLabel, setSelectedFlatLabel] = useState("");

  const [availableFlats, setAvailableFlats] = useState([]);
  const [availLoading, setAvailLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");

  const [agreed, setAgreed] = useState(false);

  const [registerError, setRegisterError] = useState("");
  const [registering, setRegistering] = useState(false);

  const navigate = useNavigate();

  const handleFetch = async () => {
    setFetchError("");
    setCommunity(null);
    setShowRegisterForm(false);

    setSelectedBlockId("");
    setSelectedFloorNumber(null);
    setSelectedFlatLabel("");
    setAvailableFlats([]);

    const id = communityId.trim();
    if (!id) {
      setFetchError("Please enter a Community ID.");
      return;
    }

    try {
      setFetching(true);
      const result = await fetchCommunityById(id);
      setCommunity(result);
    } catch (err) {
      console.error("Fetch community error:", err.code, err.message);
      setFetchError(err.message || "Unable to fetch community.");
    } finally {
      setFetching(false);
    }
  };

  const handleProceedToRegister = () => {
    setShowRegisterForm(true);
    setRegisterError("");
  };

  const blocks = useMemo(() => {
    if (!community?.data?.blocks || !Array.isArray(community.data.blocks))
      return [];
    return community.data.blocks;
  }, [community]);

  const floorOptions = useMemo(() => {
    const block = blocks.find((b) => b.id === selectedBlockId);
    if (!block) return [];
    return buildFloorLabels(block);
  }, [blocks, selectedBlockId]);

  const refreshAvailableFlats = async () => {
    setAvailableFlats([]);
    setSelectedFlatLabel("");
    setAvailLoading(true);
    try {
      const block = blocks.find((b) => b.id === selectedBlockId);
      if (!block || selectedFloorNumber === null) return;

      const all = buildFlatsForFloor(block, selectedFloorNumber);
      const occupancy = block.occupancy || {};
      const avail = all.filter((label) => !occupancy[label]);
      setAvailableFlats(avail);
    } finally {
      setAvailLoading(false);
    }
  };

  const handleRegister = async () => {
    setRegisterError("");

    if (!community?.id) return setRegisterError("Please fetch your community first.");
    if (!selectedBlockId) return setRegisterError("Please select a block.");
    if (selectedFloorNumber === null) return setRegisterError("Please select a floor.");
    if (!selectedFlatLabel) return setRegisterError("Please select a flat number.");
    if (!email || !password) return setRegisterError("Please enter email and password.");
    if (!agreed) return setRegisterError("Please agree to the terms to continue.");

    const block = blocks.find((b) => b.id === selectedBlockId);
    if (!block) return setRegisterError("Invalid block selection.");

    try {
      setRegistering(true);

      // 1) Create auth user
      const { user } = await createUserWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );
      console.log("[register] created user:", user.uid, user.email);

      // 2) Claim flat in a transaction
      const communityRef = doc(db, "communities", community.id);
      await runTransaction(db, async (t) => {
        const snap = await t.get(communityRef);
        if (!snap.exists()) throw new Error("Community not found during claim.");
        const data = snap.data();
        const blocksArr = Array.isArray(data.blocks) ? [...data.blocks] : [];
        const idx = blocksArr.findIndex((b) => b.id === selectedBlockId);
        if (idx < 0) throw new Error("Selected block not found.");

        const target = { ...blocksArr[idx] };
        const occupancy = { ...(target.occupancy || {}) };
        if (occupancy[selectedFlatLabel]) {
          throw new Error("Selected flat is already occupied. Please choose another flat.");
        }

        occupancy[selectedFlatLabel] = user.uid;
        target.occupancy = occupancy;
        blocksArr[idx] = target;

        t.update(communityRef, { blocks: blocksArr });
      });
      console.log("[register] claimed flat:", selectedFlatLabel, "in block:", block.name);

      // 3) Save user profile (Firestore)
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);
      const existing = userSnap.exists() ? userSnap.data() : {};
      const communities = Array.isArray(existing.communities)
        ? Array.from(new Set([...existing.communities, community.id]))
        : [community.id];

      await setDoc(
        userRef,
        {
          uid: user.uid,
          role: "resident",
          email: email.trim(),
          fullName: fullName.trim() || null,
          mobile: mobile.trim() || null,
          communities,
          unit: {
            communityId: community.id,
            blockName: block.name,
            floorNumber: selectedFloorNumber,
            flatLabel: selectedFlatLabel,
          },
          status: "pending",
          profileCompleted: true,
          authProvider: "password",
          createdAt: Timestamp.now(),
        },
        { merge: true }
      );
      console.log("[register] saved profile in Firestore for", user.uid);

      // 4) Send the verification email
      const ok = await sendVerificationWithLogs(user, community.id, fullName);
      if (!ok) {
        setRegisterError(
          "We couldn’t send the verification email. Please use 'Resend verification' or check your spam folder."
        );
      }

      // 5) Navigate to Check Email page (public route)
      navigate(
        `/check-email?community=${encodeURIComponent(community.id)}&email=${encodeURIComponent(
          email.trim()
        )}`
      );
    } catch (err) {
      console.error("Register error:", err.code, err.message, err);
      // cleanup newly created auth user on failure
      if (auth.currentUser) {
        try {
          await deleteUser(auth.currentUser);
        } catch (cleanupErr) {
          console.warn("Could not delete newly created user:", cleanupErr);
        }
        await signOut(auth).catch(() => {});
      }
      setRegisterError(err?.message || "Registration failed. Please try again.");
    } finally {
      setRegistering(false);
    }
  };

  const resetCommunity = () => {
    setCommunity(null);
    setCommunityId("");
    setFetchError("");
    setShowRegisterForm(false);

    setSelectedBlockId("");
    setSelectedFloorNumber(null);
    setSelectedFlatLabel("");
    setAvailableFlats([]);

    setEmail("");
    setPassword("");
    setFullName("");
    setMobile("");
    setAgreed(false);
    setRegisterError("");
  };

  return (
    <Container className="py-4 py-md-5" style={{ minHeight: "100vh" }}>
      <Row className="justify-content-center">
        <Col xs={12} lg={10} xl={9}>
          <Card className="overflow-hidden shadow register-card rounded-4">
            <Row className="g-0">
              {/* Left visual */}
              <Col md={5} className="d-none d-md-block">
                <div className="register-visual h-100">
                  <img
                    src={IMAGE_URL}
                    alt="Welcome to your community"
                    className="register-visual-img"
                  />
                  <div className="register-visual-overlay">
                    <div className="register-visual-text">
                      <h2 className="mb-1">Join your community</h2>
                      <p className="mb-0">Simple registration. Secure access.</p>
                    </div>
                  </div>
                </div>
              </Col>

              {/* Right form */}
              <Col xs={12} md={7}>
                <Card.Body className="p-3 p-md-4">
                  <h2 className="mb-1">Resident Registration</h2>
                  <p className="text-muted mb-4">
                    Find your community, pick your flat, and create your account.
                  </p>

                  {/* Step 1 */}
                  <section className="mb-4 pb-3 border-bottom">
                    <h5 className="mb-3">Step 1: Identify Your Community</h5>

                    {fetchError && <Alert variant="danger">{fetchError}</Alert>}

                    {!community ? (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>Community ID</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="e.g., ABC12345"
                            value={communityId}
                            onChange={(e) => setCommunityId(e.target.value.toUpperCase())}
                          />
                        </Form.Group>

                        <Button className="primary-cta" onClick={handleFetch} disabled={fetching}>
                          {fetching ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" /> Fetching…
                            </>
                          ) : (
                            "Fetch"
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Alert variant="info">
                          <div>
                            <strong>Community ID:</strong> <code>{community.id}</code>
                          </div>
                          <div>
                            <strong>Name:</strong> {community.data.name}
                          </div>
                          <div>
                            <strong>Address:</strong> {community.data.address}
                          </div>
                          {community.data.description && (
                            <div>
                              <strong>Description:</strong> {community.data.description}
                            </div>
                          )}
                        </Alert>
                        <div className="d-flex gap-2">
                          <Button variant="outline-secondary" onClick={resetCommunity}>
                            Check another Community
                          </Button>
                          <Button className="primary-cta" onClick={handleProceedToRegister}>
                            Proceed to Register
                          </Button>
                        </div>
                      </>
                    )}
                  </section>

                  {/* Step 2 */}
                  {community && showRegisterForm && (
                    <section>
                      <h5 className="mb-3">Step 2: Choose Block / Floor / Flat</h5>

                      <Row className="g-2">
                        {/* Block */}
                        <Form.Group as={Col} xs={12} md={4} className="mb-3">
                          <Form.Label>Block</Form.Label>
                          <Form.Select
                            value={selectedBlockId}
                            onChange={(e) => {
                              setSelectedBlockId(e.target.value);
                              setSelectedFloorNumber(null);
                              setSelectedFlatLabel("");
                              setAvailableFlats([]);
                            }}
                          >
                            <option value="">Select block</option>
                            {blocks.map((b) => (
                              <option key={b.id} value={b.id}>
                                {b.name} - Block
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>

                        {/* Floor */}
                        <Form.Group as={Col} xs={12} md={4} className="mb-3">
                          <Form.Label>Floor</Form.Label>
                          <Form.Select
                            value={selectedFloorNumber ?? ""}
                            disabled={!selectedBlockId}
                            onChange={(e) => {
                              const val =
                                e.target.value === "" ? null : Number(e.target.value);
                              setSelectedFloorNumber(val);
                              setSelectedFlatLabel("");
                              setAvailableFlats([]);
                            }}
                            onBlur={refreshAvailableFlats}
                            onFocus={() => {
                              if (selectedBlockId && selectedFloorNumber !== null)
                                refreshAvailableFlats();
                            }}
                          >
                            <option value="">Select floor</option>
                            {floorOptions.map(({ label, floorNumber }) => (
                              <option key={`floor-${floorNumber}`} value={floorNumber}>
                                {label}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Text muted>
                            Ground availability uses the same numbering pattern as upper floors.
                          </Form.Text>
                        </Form.Group>

                        {/* Flat */}
                        <Form.Group as={Col} xs={12} md={4} className="mb-3">
                          <Form.Label>Flat number</Form.Label>
                          <Form.Select
                            value={selectedFlatLabel}
                            disabled={!selectedBlockId || selectedFloorNumber === null}
                            onFocus={refreshAvailableFlats}
                            onChange={(e) => setSelectedFlatLabel(e.target.value)}
                          >
                            <option value="">
                              {availLoading ? "Checking availability…" : "Select available flat"}
                            </option>
                            {!availLoading &&
                              availableFlats.map((label) => (
                                <option key={label} value={label}>
                                  {label}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Row>

                      <hr />

                      {/* Account info */}
                      <Form.Group className="mb-3">
                        <Form.Label>Full name (optional)</Form.Label>
                        <Form.Control
                          type="text"
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                          placeholder="e.g., Rahul Sharma"
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Mobile (optional)</Form.Label>
                        <Form.Control
                          type="text"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          placeholder="e.g., 9876543210"
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          autoComplete="username"
                          placeholder="name@example.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type="password"
                          autoComplete="new-password"
                          placeholder="Enter a strong password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </Form.Group>

                      {/* ✅ Terms */}
                      <Form.Group className="mb-3">
                        <Form.Check
                          id="agree-terms"
                          type="checkbox"
                          label="I agree to the Terms & Privacy Policy."
                          checked={agreed}
                          onChange={(e) => setAgreed(e.target.checked)}
                        />
                      </Form.Group>

                      {registerError && (
                        <Alert variant="danger" className="mb-3">
                          {registerError}
                        </Alert>
                      )}

                      <div className="register-action-bar">
                        <Button className="primary-cta" onClick={handleRegister} disabled={registering}>
                          {registering ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" /> Registering…
                            </>
                          ) : (
                            "Register"
                          )}
                        </Button>
                      </div>
                    </section>
                  )}

                  <p className="mt-4 mb-0 text-muted">Your safety is our prime priority.</p>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
